import createReduce from './_createReduce.js';

// **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
export default createReduce(1);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/reduce.js
// module id = 1599
// module chunks = 106